import React from "react";
import ReactDOM from "react-dom/client"; // NOTE the /client
import App from "./App";
import './styles/index.css';

// The "root" element must exist in your public/index.html
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
